import { scroller } from './scroll';

export function getInTouch(element: HTMLElement): void {
  const parent = element.parentElement;

  document.addEventListener('click', (e) => {
    if (e.target == element) {
      return
    }
    parent?.classList.remove('open');
  });

  element.addEventListener('click', (e) => {
    e.preventDefault();
    parent?.classList.toggle('open');
  });

  document.querySelector('.js_get_in_touch__close')?.addEventListener('click', (e) => {
    e.preventDefault();
    parent?.classList.remove('open');
  });

  scroller.on('scroll', (e) => {
    parent?.classList.remove('open');
  });
}